import styled, { css } from 'styled-components';

// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — custom-select.styled.classic.js, новая — custom-select.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './custom-select.styled.classic';
import * as cp from './custom-select.styled.cp';

export const ArrowDown = isCp ? cp.ArrowDown : classic.ArrowDown;
export const Container = isCp ? cp.Container : classic.Container;
export const Header = isCp ? cp.Header : classic.Header;
export const List = isCp ? cp.List : classic.List;
export const ListContainer = isCp ? cp.ListContainer : classic.ListContainer;
export const ListItem = isCp ? cp.ListItem : classic.ListItem;

// Контейнер списка: ширина строго равна ширине шапки (перебивает min-width/width у .priority и .vehicle-class)
export const MenuContainer = styled(Container)`
  min-width: 0 !important;
  width: 100% !important;
  li {
    width: auto !important;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  /* список над инпутом: тот же зазор, что и снизу, но с другой стороны */
  ${(props) =>
    props.$gap !== undefined &&
    css`
      ul {
        margin-top: 0 !important;
        margin-bottom: ${props.$gap}px !important;
      }
    `}
`;
